import CancelHotelRoom from '@/views/CancelHotelRoom/index.vue'

const CancelHotelRoomRouter = {
  path: '/cancel-hotel-room',
  name: 'CancelHotelRoom',
  component: CancelHotelRoom,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default CancelHotelRoomRouter
